// Styles
import * as S from './styles'

import { Authorize } from 'components/Authorize/Authorize'
import { PERMISSIONS } from '../../../../../constants'
import type { GroupProps } from '../GroupItem'
import { GroupItem } from '../GroupItem'

type MenuItemProps = {
  session_name: string
  session_permissions: PERMISSIONS[]
  session_groups: GroupProps[]
}

export const MenuSection = ({
  session_name,
  session_groups
}: MenuItemProps) => {
  return (
    <div>
      <S.Title>{session_name}</S.Title>
      {session_groups.map(
        ({
          group_name,
          group_permissions,
          icon,
          group_list,
          href,
          id,
          target_new,
          action
        }) => {
          return (
            <Authorize key={group_name} permissions={group_permissions}>
              <GroupItem
                group_name={group_name}
                group_permissions={group_permissions}
                icon={icon}
                group_list={group_list}
                href={href}
                id={id}
                target_new={target_new}
                action={action}
              />
            </Authorize>
          )
        }
      )}
    </div>
  )
}
